import { UserStore } from "../../../plugins/auth/model/UserStore";
export class EzPayQualifier {
    constructor() {
        this.key = "EzPay";
    }
    async process() {
        var _a;
        const user = UserStore.getUser();
        // Not logged in
        if (!user || !user.UserState || user.UserState === "LoggedOut") {
            return "false";
        }
        const subscription = (_a = user.Subscriptions) === null || _a === void 0 ? void 0 : _a[0];
        // No subscription
        if (!subscription) {
            return "false";
        }
        // Compare IsEZPay
        return String(subscription.IsEZPay);
    }
}
